import { render, staticRenderFns } from "./BullhornIcon.vue?vue&type=template&id=1a62a624"
import script from "./BullhornIcon.vue?vue&type=script&lang=js"
export * from "./BullhornIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports